var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0344 10.001H16.8734L15.7124 10.94V15.597C15.7124 17.326 17.1134 18.728 18.8424 18.728C20.5724 18.728 21.9734 17.326 21.9734 15.597V10.94C21.9734 10.422 21.5534 10.001 21.0344 10.001Z",
    fill: "#5059C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 7C22 8.104 21.105 9 20 9C18.895 9 18 8.104 18 7C18 5.896 18.895 5 20 5C21.105 5 22 5.896 22 7Z",
    fill: "#5059C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89214 10.0044H17.0961C17.5921 10.0044 17.9941 10.4064 17.9941 10.9024V16.5944C17.9941 19.0304 16.0201 21.0044 13.5841 21.0044H13.4041C10.9681 21.0044 8.99414 19.0304 8.99414 16.5944V10.9024C8.99414 10.4064 9.39614 10.0044 9.89214 10.0044Z",
    fill: "#7B83EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9068 5.99977C16.9068 7.60477 15.6058 8.90677 13.9997 8.90677C12.3947 8.90677 11.0938 7.60477 11.0938 5.99977C11.0938 4.39477 12.3947 3.09277 13.9997 3.09277C15.6058 3.09277 16.9068 4.39477 16.9068 5.99977Z",
    fill: "#7B83EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0001 8.68149V8.00049C15.0001 7.45049 14.5281 7.00049 13.9511 7.00049H11.2711C11.6881 8.09449 12.7391 8.87549 13.9801 8.87549C14.3401 8.87549 14.6821 8.80149 15.0001 8.68149ZM8.99414 10.9025C8.99414 10.4065 9.39614 10.0045 9.89214 10.0045H15.0001V17.8395C15.0001 18.3895 14.3821 19.0005 13.7451 19.0005H9.71514C9.26214 18.3075 8.99414 17.4835 8.99414 16.5945V10.9025Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 18C2.45 18 2 17.55 2 17V7C2 6.45 2.45 6 3 6H13C13.55 6 14 6.45 14 7V17C14 17.55 13.55 18 13 18H3Z",
    fill: "#4B53BC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0004 9.99982H8.83535V15.8198H7.41235V9.99982H5.23535V8.56982H11.0004V9.99982Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/Teams.7c1c562169369edcfc18b25a1e43d57d.svg";
export { ForwardRef as ReactComponent };